module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-four-new-smc/key-2-2020.svg?v=8dc2cd9f";